module.exports = __webpack_public_path__ + "static/OpenSans-Bold-1025a6e0fb0fa86f17f57cc82a6b9756.ttf";